import React, { useState, useEffect, useRef } from "react";
import { addbuildsheet, updatebuildsheetdata } from "../../Api/buildsheetApi"
import Spinner from 'react-bootstrap/Spinner';
import { getModeldatabymake } from "../../Api/inventoryApi";
import { Form } from "react-bootstrap";
import { getCurrentUser } from "../../Api/auth";
import { useLocation } from 'react-router-dom';
import { FaAngleUp } from "react-icons/fa";
import { Tab, Tabs, Accordion } from "react-bootstrap";

const updateNestedState = (state, path, value) => {
    const keys = path.split('.');
    const lastKey = keys.pop();
    const nestedState = { ...state };

    let current = nestedState;
    keys.forEach(key => {
        if (!current[key]) {
            current[key] = {};
        }
        current = current[key];
    });

    current[lastKey] = value;
    return nestedState;
};

function DriverWood({ project_id, project_step = "history", title, user_id, fitter_name, selecteddata, ondeleteChange, remortFittingFormData, makedata, type_id, selectoptiondata, shaftdata, gripdata, allmodels }) {

    const [apicall, setApicall] = useState(false);
    const [validated, setValidated] = useState(false);
    const [apicallupate, setApicallUpate] = useState(false);
    const [buildSheetStatus, setBuildSheetStatus] = useState(false);
    const [builsheetid, setBuildSheetId] = useState(null);
    const [modeldata, setModelData] = useState([]);

    const [shaftmodeldata, setShaftModelData] = useState([]);
    const [gripmodeldata, setGripModelData] = useState([]);
    const [isDisabled, setIsDisabled] = useState(false);

    const location = useLocation(); // Get location object
    const pathSegments = location.pathname.split('/'); // Split the path
    const result = pathSegments[1]; // Extract 'builder-project-view'

    const weights = [];
    for (let i = 40; i <= 90; i += 5) {
        weights.push(i);
    }

    const flexes = [];
    for (let i = 200; i <= 280; i += 5) {
        flexes.push(i);
    }

    const lengths = [];
    for (let i = 41; i <= 46; i += .5) {
        lengths.push(i);
    }

    const trippings = [];
    for (let i = 0.5; i <= 6; i += 0.5) {
        trippings.push(i);
    }

    const counterBalances = [6, 12, 18, 24];

    const gripSize = ['Under Size', 'Standard', 'Mid Size', 'Jumbo'];

    const gripLabels = ['Up', 'Down'];

    const [dynamictitle, setDynamicTitle] = useState('');

    const [isShaftWrapCheckboxChecked, setIsShaftWrapCheckboxChecked] = useState(false);
    const [isCounterCheckboxChecked, setCounterCheckboxChecked] = useState(false);
    const [isTippingCheckboxChecked, setIsTippingCheckboxChecked] = useState(false);

    const handleCheckboxChange = () => {
        setIsShaftWrapCheckboxChecked(!isShaftWrapCheckboxChecked);

        setBuildSheetData(prevState => updateNestedState(prevState, 'ShaftWrapStatus', !isShaftWrapCheckboxChecked));
    };

    const handleCheckboxChangeTipping = () => {
        setIsTippingCheckboxChecked(!isTippingCheckboxChecked);

        setBuildSheetData(prevState => updateNestedState(prevState, 'TippingStatus', !isTippingCheckboxChecked));
    };

    const handleCounterCheckboxChecked = () => {
        setCounterCheckboxChecked(!isCounterCheckboxChecked);

        setBuildSheetData(prevState => updateNestedState(prevState, 'CounterBalanceStatus', !isCounterCheckboxChecked));
    };

    useEffect(() => {

        var showname = "";
        let parts = title.split(" ");
        if (parts.length > 1) {
            showname = parts[1];
        } else {
            showname = parts[0];
        }

        if (showname === "Driver") {
            setDynamicTitle("Driver");
        }
        if (showname === "Wood") {
            setDynamicTitle("Wood");
        }

    }, [title]);


    const [buildSheetData, setBuildSheetData] = useState({
        ClubHead: {
            make: '',
            model: '',
        },
        Loft: '',
        Lie: '',
        ClubHeadNotes: '',
        WeightPorts: {
            color: '',
            weight: ''
        },
        WeightPortNotes: '',
        Shaft: {
            make: '',
            model: '',
        },
        Weight: '',
        Flex: '',
        Length: '',
        ShaftWrap: '',
        ShaftNotes: '',
        CounterBalance: '',
        Grip: {
            brand: '',
            model: '',
            size: '',
            label: '',
        },
        GripWrapStatus: false,
        GripWrapValue: '',
        GripNotes: '',
        Ferrule: '',
        CGSettings: '',
        AdapterSettings: '',
        LoftLie: '',
        Tripping: '',
        ShaftWrapStatus: false,
        CounterBalanceStatus: false,
    });


    const handleChange = (e) => {
        const { name, value } = e.target;
        setBuildSheetData(prevState => updateNestedState(prevState, name, value));

        if (e.target.name === "ClubHead.make") {
            var type_id = "";
            if (dynamictitle === "Driver") {
                type_id = "1";
            }
            if (dynamictitle === "Wood") {
                type_id = "2";
            }
            const data = {
                make_id: e.target.value,
                type_id: type_id
            }
            // getModeldatabymake(data).then((response) => {
            //     console.log("aminesh",4);
            //     if (!response.data.status) {
            //         console.log(response.data.message);
            //     } else {
            //         const data = response.data.data;
            //         setModelData(data);
            //     }
            // }).catch((err) => {
            //     alert(err);
            // })
            const filterdata = allmodels.filter((item) => item.Make === e.target.value && item.type_id === type_id);
            setModelData(filterdata);
        }

        if (e.target.name === "Shaft.make") {
            const data = {
                make_id: e.target.value,
                type_id: "7"
            }
            // getModeldatabymake(data).then((response) => {
            //     console.log("aminesh",4);
            //     if (!response.data.status) {
            //         console.log(response.data.message);
            //     } else {
            //         const data = response.data.data;
            //         setShaftModelData(data);
            //     }
            // }).catch((err) => {
            //     alert(err);
            // })
            const filtershaftdata = allmodels.filter((item) => item.Make === e.target.value && item.type_id === "7");
            setShaftModelData(filtershaftdata);
        }

        if (e.target.name === "Grip.brand") {
            const data = {
                make_id: e.target.value,
                type_id: "8"
            }
            // getModeldatabymake(data).then((response) => {
            //     console.log("aminesh",5);
            //     if (!response.data.status) {
            //         console.log(response.data.message);
            //     } else {
            //         const data = response.data.data;
            //         setGripModelData(data);
            //     }
            // }).catch((err) => {
            //     alert(err);
            // })
            const filtergripdata = allmodels.filter((item) => item.Make === e.target.value && item.type_id === "8");
            setGripModelData(filtergripdata);
        }

    };

    const submitdata = (e) => {
        e.preventDefault();
        setApicallUpate(true);
        const data = {
            builsheetnumber: title,
            buildSheetData: buildSheetData,
            project_id: project_id,
            user_id: user_id,
            fitter_name: fitter_name,
            type_id: type_id
        }
        addbuildsheet(data).then((response) => {
            if (!response.data.status) {
                console.log(response.data.message);
            } else {
                const data = response.data.data;
                // handleClose();
                // getDataById();
                // getbuildSheetDataById();
            }
        }).catch((err) => {
            console.log(err);
        }).finally(() => {
            setApicall(false);
            setValidated(true);
        }).finally(() => {
            setApicallUpate(false);
            ondeleteChange("driver&Wood");
        })
    }


    useEffect(() => {
        if (selecteddata) {
            setBuildSheetData(selecteddata);
            setBuildSheetStatus(selecteddata.update_status);
            setBuildSheetId(selecteddata._id);
            setIsShaftWrapCheckboxChecked(selecteddata.ShaftWrapStatus);
            setCounterCheckboxChecked(selecteddata.CounterBalanceStatus);
            setIsTippingCheckboxChecked(selecteddata.TippingStatus);
        }
    }, [selecteddata]);


    useEffect(() => {
        if (buildSheetData?.ClubHead?.make !== '') {
            handleChange({ target: { name: "ClubHead.make", value: buildSheetData?.ClubHead?.make } });
        }
    }, [buildSheetData?.ClubHead?.make]);

    useEffect(() => {
        if (buildSheetData?.Shaft?.make !== '') {
            handleChange({ target: { name: "Shaft.make", value: buildSheetData?.Shaft?.make } });
        }
    }, [buildSheetData?.Shaft?.make]);

    useEffect(() => {
        if (buildSheetData?.Grip?.brand !== '') {
            handleChange({ target: { name: "Grip.brand", value: buildSheetData?.Grip?.brand } });
        }
    }, [buildSheetData?.Grip?.brand]);

    const updateclub = (e) => {
        e.preventDefault();
        setApicallUpate(true);
        const data = {
            id: builsheetid,
            buildSheetData: buildSheetData
        }
        updatebuildsheetdata(data).then((res) => {
            if (res?.code === 200) {
                ondeleteChange("driver&Wood")
            } else {
                alert(res?.message);
            }
        }).catch((err) => {
            alert(err);
        }).finally(() => {
            setApicallUpate(false);
        })
    }

    useEffect(() => {
        if (selectoptiondata) {
            if (selectoptiondata !== 'Unassigned') {
                setIsDisabled(true);
            } else {
                setIsDisabled(false);
            }
        }
    }, [selectoptiondata]);


    const [userdata, setUserdata] = useState('');
    const formRef = useRef(null);

    useEffect(() => {
        const getCurrentUserdata = getCurrentUser();
        // setUserdata(getCurrentUserdata.user);
        // setUser_id(getCurrentUserdata.user._id);


        if (getCurrentUserdata && getCurrentUserdata.user) {
            setUserdata(getCurrentUserdata.user);
        } else {
            console.error("Current user data is null or undefined");
        }

    }, []);

    useEffect(() => {
        if (formRef.current) {
            // Check if roleId is 7 and apply disabled state
            if (userdata.role_id == 7) {
                formRef.current.querySelectorAll('input, button, textarea, select').forEach(el => {
                    el.disabled = true; // Disable inputs and buttons
                });
            }
            // else {
            //     formRef.current.querySelectorAll('input, button, textarea, select').forEach(el => {
            //         el.disabled = false; // Enable inputs and buttons
            //     });
            // }
        }
    }, [userdata]);


    useEffect(() => {
        console.log("firsttttttt");
        if (formRef.current && result === 'builder-project-view') {
            console.log("seconddddddd");
            const elements = formRef.current.querySelectorAll('input, button, textarea, select');
            elements.forEach((el) => {
                el.disabled = true; // Disable inputs and buttons
            });
        }
    }, [result]); // Dependency ensures this runs when `result` changes


    const gripWrapOptions = [1, 2, 3, 4, 5];

    const handleGripWrapCheckbox = () => {
        setBuildSheetData(prevState => {
            const newStatus = !prevState.GripWrapStatus;
            return {
                ...prevState,
                GripWrapStatus: newStatus,
                GripWrapValue: newStatus ? prevState.GripWrapValue : ""
            };
        });
    };

    const handleGripWrapChange = (event) => {
        setBuildSheetData(prevState => ({
            ...prevState,
            GripWrapValue: event.target.value
        }));
    };


    //New code
    const initialPrescriptionStateNew = {
        bounce: '',
        lieage: '',
        shaftweight: '',
        shaftflex: '',
        shaftprofile: '',
        gripSize: '',
        clubLength: '',
        swingWeight: '',

        bounceselect: '',
        lieageselect: '',
        shaftweightselect: '',
        shaftflexselect: '',
        shaftprofileselect: '',
        gripSizeselect: '',
        clubLengthselect: '',
        swingWeightselect: '',
    };

    const [prescriptionNew, setPrescriptionNew] = useState(initialPrescriptionStateNew);

    const [optimalHeads, setOptimalHeads] = useState(0);
    const [optimalShafts, setOptimalShafts] = useState(0);
    const [optimalGrips, setOptimalGrips] = useState(0);

    useEffect(() => {
        if (remortFittingFormData) {
            setPrescriptionNew(remortFittingFormData?.fittingdata);
            setOptimalHeads(parseInt(remortFittingFormData?.optimalHeadsStar));
            setOptimalShafts(parseInt(remortFittingFormData?.optimalShaftsStar));
            setOptimalGrips(parseInt(remortFittingFormData?.optimalGripsStar));
        }
    }, [remortFittingFormData]);


    const getselectbounce = (category, value) => {
        const selectedValue = parseInt(value);

        // Define options for each category
        const options = {
            bounce: {
                1: 'Low Bounce',
                2: 'Mid Bounce',
                3: 'High Bounce'
            },
            lieAngle: {
                1: 'Upright',
                2: 'Standard',
                3: 'Flat'
            },
            shaftWeight: {
                1: 'Heavy',
                2: 'Medium',
                3: 'Light'
            },
            shaftFlex: {
                1: 'Hard',
                2: 'Medium',
                3: 'Soft'
            },
            shaftProfile: {
                1: 'Firm Tip',
                2: 'Soft Mid',
                3: 'Firm Butt'
            },
            gripSize: {
                1: 'Oversize',
                2: 'Mid',
                3: 'Standard'
            },
            clubLength: {
                1: 'Long',
                2: 'Medium',
                3: 'Short'
            },
            swingWeight: {
                1: 'Heavy',
                2: 'Medium',
                3: 'Light'
            }
        };

        // Return the option label based on category and selected value
        return options[category]?.[selectedValue] || `Select ${category.replace(/([A-Z])/g, ' $1').trim()}`;
    };

    const [optimalHeadsobject, setOptimalHeadsobject] = useState({
        option1: { make: '', model: '' },
        option2: { make: '', model: '' },
        option3: { make: '', model: '' }
    });

    const [optimalShaftsobject, setOptimalShaftsobject] = useState({
        option1: { make: '', model: '' },
        option2: { make: '', model: '' },
        option3: { make: '', model: '' }
    });

    const [optimalGripsobject, setOptimalGripsobject] = useState({
        option1: { make: '', model: '' },
        option2: { make: '', model: '' },
        option3: { make: '', model: '' }
    });


    useEffect(() => {
        if (remortFittingFormData?.optimalHeads) {
            setOptimalHeadsobject(prevState => ({
                ...prevState, // Preserve any existing data
                ...remortFittingFormData.optimalHeads // Update with new data
            }));

            setOptimalHeads(Number(remortFittingFormData?.optimalHeadsStar));
        }

        if (remortFittingFormData?.optimalShafts) {
            setOptimalShaftsobject(prevState => ({
                ...prevState,
                ...remortFittingFormData.optimalShafts
            }));

            setOptimalShafts(Number(remortFittingFormData?.optimalShaftsStar));
        }

        if (remortFittingFormData?.optimalGrips) {
            setOptimalGripsobject(prevState => ({
                ...prevState,
                ...remortFittingFormData.optimalGrips
            }));
            setOptimalGrips(Number(remortFittingFormData?.optimalGripsStar));
        }

        //also check 
    }, [remortFittingFormData]);

    const [head1, setHead1] = useState('');
    const [head2, setHead2] = useState('');
    const [head3, setHead3] = useState('');

    const [Shaft1, setShaft1] = useState('');
    const [Shaft2, setShaft2] = useState('');
    const [Shaft3, setShaft3] = useState('');

    const [Grip1, setGrip1] = useState('');
    const [Grip2, setGrip2] = useState('');
    const [Grip3, setGrip3] = useState('');


    const [allmodelsdata, setAllmodelsdata] = useState([]);


    useEffect(() => {
        if (allmodels && allmodels.length > 0 && allmodelsdata && allmodelsdata.length === 0) {
            setAllmodelsdata(allmodels);
        }
    }, [allmodels]);

    const handleNestedChange = (section, option, subField, value) => {

        if (allmodelsdata.length > 0) { 
            const optionKey = `option${option}`;
            let type_id = "";
            switch (section) {
                case "optimalHeads":
                    type_id = "4";
                    break;
                case "optimalShafts":
                    type_id = "7";
                    break;
                case "optimalGrips":
                    type_id = "8";
                    break;
                default:
                    break;
            }

            // Filter the models from allmodels array
            const filteredModels = allmodelsdata.filter(model =>
                model.Make === value && model.type_id === type_id
            );


            // Set the data based on section, subField, and option
            if (filteredModels.length > 0) {
                const data = filteredModels;

                if (section === 'optimalHeads') {
                    switch (option) {
                        case 1:
                            console.log('head 1', data);
                            setHead1(data);
                            break;
                        case 2:
                            setHead2(data);
                            break;
                        case 3:
                            setHead3(data);
                            break;
                        default:
                            break;
                    }
                }

                if (section === 'optimalShafts') {
                    switch (option) {
                        case 1:
                            setShaft1(data);
                            break;
                        case 2:
                            setShaft2(data);
                            break;
                        case 3:
                            setShaft3(data);
                            break;
                        default:
                            break;
                    }
                }

                if (section === 'optimalGrips') {
                    switch (option) {
                        case 1:
                            setGrip1(data);
                            break;
                        case 2:
                            setGrip2(data);
                            break;
                        case 3:
                            setGrip3(data);
                            break;
                        default:
                            break;
                    }
                }

                const updateData = (setFunction, currentData) => {
                    setFunction(prevData => ({
                        ...prevData,
                        [optionKey]: { // Update the correct option (option1, option2, option3)
                            ...prevData[optionKey],
                            [subField]: value // Update the specific field (make or model)
                        }
                    }));
                };

                // Update the correct section (optimalHeads, optimalShafts, or optimalGrips)
                if (section === 'optimalHeads') {
                    updateData(setOptimalHeadsobject, optimalHeadsobject);
                } else if (section === 'optimalShafts') {
                    updateData(setOptimalShaftsobject, optimalShaftsobject);
                } else if (section === 'optimalGrips') {
                    updateData(setOptimalGripsobject, optimalGripsobject);
                }
            } else {
                console.log("");
            }
        }
    };


    useEffect(() => {
        if (allmodelsdata.length > 0) {
            handleNestedChange('optimalHeads', 1, 'make', remortFittingFormData?.optimalHeads?.option1?.make);
            handleNestedChange('optimalHeads', 2, 'make', remortFittingFormData?.optimalHeads?.option2?.make);
            handleNestedChange('optimalHeads', 3, 'make', remortFittingFormData?.optimalHeads?.option3?.make);

            handleNestedChange('optimalShafts', 1, 'make', remortFittingFormData?.optimalShafts?.option1?.make);
            handleNestedChange('optimalShafts', 2, 'make', remortFittingFormData?.optimalShafts?.option2?.make);
            handleNestedChange('optimalShafts', 3, 'make', remortFittingFormData?.optimalShafts?.option3?.make);

            handleNestedChange('optimalGrips', 1, 'make', remortFittingFormData?.optimalGrips?.option1?.make);
            handleNestedChange('optimalGrips', 2, 'make', remortFittingFormData?.optimalGrips?.option2?.make);
            handleNestedChange('optimalGrips', 3, 'make', remortFittingFormData?.optimalGrips?.option3?.make);
        }

    }, [allmodelsdata]);


    return (

        <>
            <Form ref={formRef}>
                <fieldset disabled={isDisabled}>
                    <div className="row d-flex align-items-center ">
                        <div className="scrollable-section col-12 col-sm-6" style={{ overflowX: "hidden" }}>
                            <div className='row'>
                                <div className='col-md-12'>
                                    <div className='form-group'>
                                        <div className='form-group-label'>
                                            <label className='form-label'>Club Head</label>
                                        </div>
                                        <div className='form-group-input mb-4'>
                                            <select style={{ textTransform: "capitalize" }} name="ClubHead.make" value={buildSheetData?.ClubHead?.make || ""} onChange={handleChange} class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example">
                                                <option value="" disabled >Make</option>
                                                {makedata && makedata.map((item) => (
                                                    <option value={item._id} key={item._id}>{item.brand_name}</option>
                                                ))}
                                                {/* <option value="1">1 ft.</option>
                                <option value="2">2 ft.</option>
                                <option value="3">3 ft.</option> */}
                                            </select>
                                        </div>
                                        <div className='form-group-input'>
                                            <select style={{ textTransform: "capitalize" }} name="ClubHead.model" value={buildSheetData?.ClubHead?.model || ""} onChange={handleChange} class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example">
                                                <option value="" disabled>Model</option>
                                                {modeldata && modeldata.map((item) => (
                                                    <option value={item._id} key={item._id}>{item.ModelName}</option>
                                                ))}
                                                {/* <option value="1">1 ft.</option>
                                <option value="2">2 ft.</option>
                                <option value="3">3 ft.</option> */}
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='row'>
                                <div className='col-md-12'>
                                    <div className='form-group'>
                                        <div className='form-group-label'>
                                            <label className='form-label'>Loft & Lie</label>
                                        </div>
                                        <div className='form-group-input'>
                                            <textarea name="LoftLie" value={buildSheetData?.LoftLie || ""} onChange={handleChange} class="form-control dashboard-text-area" id="exampleFormControlTextarea1" rows="8" ></textarea>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='row'>
                                <div className='col-md-12'>
                                    <div className='form-group'>
                                        <div className='form-group-label'>
                                            <label className='form-label'>CG Settings</label>
                                        </div>
                                        <div className='form-group-input'>
                                            <textarea name="CGSettings" value={buildSheetData?.CGSettings || ""} onChange={handleChange} class="form-control dashboard-text-area" id="exampleFormControlTextarea1" rows="8" ></textarea>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='row'>
                                <div className='col-md-12'>
                                    <div className='form-group'>
                                        <div className='form-group-label'>
                                            <label className='form-label'>Adapter Settings</label>
                                        </div>
                                        <div className='form-group-input'>
                                            <textarea name="AdapterSettings" value={buildSheetData?.AdapterSettings || ""} onChange={handleChange} class="form-control dashboard-text-area" id="exampleFormControlTextarea1" rows="8" ></textarea>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='row'>
                                <div className='col-md-12'>
                                    <div className='form-group'>
                                        <div className='form-group-label'>
                                            <label className='form-label'>Shaft</label>
                                        </div>
                                        <div className='form-group-input mb-4'>
                                            <select style={{ textTransform: "capitalize" }} name="Shaft.make" value={buildSheetData?.Shaft?.make || ""} onChange={handleChange} class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example">
                                                <option value="" disabled>Make</option>
                                                {shaftdata && shaftdata.map((item) => (
                                                    <option value={item._id} key={item._id}>{item.brand_name}</option>
                                                ))}
                                                {/* <option value="1">1 ft.</option>
                                <option value="2">2 ft.</option>
                                <option value="3">3 ft.</option> */}
                                            </select>
                                        </div>
                                        <div className='form-group-input'>
                                            <select style={{ textTransform: "capitalize" }} name="Shaft.model" value={buildSheetData?.Shaft?.model || ""} onChange={handleChange} class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example">
                                                <option value="" disabled>Model</option>
                                                {shaftmodeldata && shaftmodeldata.map((item) => (
                                                    <option value={item._id} key={item._id}>{item.ModelName}</option>
                                                ))}
                                                {/* <option value="1">1 ft.</option>
                                <option value="2">2 ft.</option>
                                <option value="3">3 ft.</option> */}
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='row'>
                                <div className='col-md-6'>
                                    <div className='form-group'>
                                        <div className='form-group-label'>
                                            <label className='form-label'>Weight</label>
                                        </div>
                                        <div className='form-group-input'>
                                            <select style={{ textTransform: "capitalize" }}
                                                name="Weight"
                                                defaultValue=""
                                                className="form-select form-control dashboard-input-box-3 select-custom-boxx"
                                                aria-label="Default select example"
                                                value={buildSheetData?.Weight || ""} onChange={handleChange}
                                            >
                                                <option value="" disabled>Weight</option>
                                                {weights.map((weight) => (
                                                    <option key={weight} value={weight}>
                                                        {weight} grams
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div className='col-md-6'>
                                    <div className='form-group'>
                                        <div className='form-group-label'>
                                            <label className='form-label'>Flex</label>
                                        </div>
                                        <div className='form-group-input'>
                                            <select style={{ textTransform: "capitalize" }}
                                                name="Flex"
                                                defaultValue=""
                                                className="form-select form-control dashboard-input-box-3 select-custom-boxx"
                                                aria-label="Default select example"
                                                value={buildSheetData?.Flex || ""} onChange={handleChange}
                                            >
                                                <option value="" disabled>Flex</option>
                                                {flexes.map((flex) => (
                                                    <option key={flex} value={flex}>
                                                        {flex} cpm
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className='col-md-6'>
                                    <div className='form-group'>
                                        <div className='form-group-label'>
                                            <label className='form-label'>Length</label>
                                        </div>
                                        <div className='form-group-input'>
                                            <select style={{ textTransform: "capitalize" }}
                                                name="Length"
                                                defaultValue=""
                                                className="form-select form-control dashboard-input-box-3 select-custom-boxx"
                                                aria-label="Default select example"
                                                value={buildSheetData?.Length || ""} onChange={handleChange}
                                            >
                                                <option value="" disabled>Length</option>
                                                {lengths.map((length) => (
                                                    <option key={length} value={length}>
                                                        {length} inch
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div className='col-md-6'>
                                    <div className='form-group'>
                                        <div className='form-group-label d-flex align-items-center justify-content-between'>
                                            <label className='form-label'>Tipping</label>
                                            <div className='form-group-check'>
                                                <input type="checkbox" className="form-check-input" checked={isTippingCheckboxChecked} onChange={handleCheckboxChangeTipping} />
                                            </div>
                                        </div>
                                        <div className='form-group-input'>
                                            <select
                                                name="Tripping"
                                                // className="form-select form-control dashboard-input-box-3 select-custom-boxx"
                                                className={`form-select form-control dashboard-input-box-3 select-custom-boxx ${!isTippingCheckboxChecked ? "select-disabled" : ""
                                                    }`}
                                                aria-label="Default select example"
                                                value={buildSheetData?.Tripping || ""} onChange={handleChange}
                                            >
                                                <option value="" disabled>Length</option>
                                                {trippings.map((length) => (
                                                    <option key={length} value={length}>
                                                        {length} inch
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='row'>
                                <div className='col-md-12'>
                                    <div className='form-group'>
                                        <div className='form-group-label d-flex align-items-center justify-content-between'>
                                            <label className='form-label'>Shaft Wrap</label>
                                            <div className='form-group-check'>
                                                <input type="checkbox" className="form-check-input" checked={isShaftWrapCheckboxChecked} onChange={handleCheckboxChange} />
                                            </div>
                                        </div>
                                        <div className='form-group-input'>
                                            <select style={{ textTransform: "capitalize" }}
                                                name="ShaftWrap"
                                                // className="form-select form-control dashboard-input-box-3 select-custom-boxx select-disabled"
                                                className={`form-select form-control dashboard-input-box-3 select-custom-boxx ${!isShaftWrapCheckboxChecked ? "select-disabled" : ""
                                                    }`}
                                                // aria-label="Default select example"
                                                value={buildSheetData?.ShaftWrap || ""}
                                                onChange={handleChange}
                                            >
                                                <option value='' selected disabled>Shaft Wrap</option>
                                                <option value={'Black'}>Black</option>
                                                <option value={'Blue'}>Blue</option>
                                                <option value={'Green'}>Green</option>
                                                <option value={'Red'}>Red</option>
                                            </select>

                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='row'>
                                <div className='col-md-12'>
                                    <div className='form-group'>
                                        <div className='form-group-label d-flex align-items-center justify-content-between'>
                                            <label className='form-label'>Shaft Notes</label>
                                        </div>
                                        <div className='form-group-input'>
                                            <textarea name="ShaftNotes" value={buildSheetData?.ShaftNotes || ""} onChange={handleChange} class="form-control dashboard-text-area" id="exampleFormControlTextarea1" rows="8" ></textarea>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='row'>
                                <div className='col-md-12'>
                                    <div className='form-group'>
                                        <div className='form-group-label d-flex align-items-center justify-content-between'>
                                            <label className='form-label'>Counter Balance</label>
                                            <div className='form-group-check'>
                                                <input type="checkbox" className="form-check-input" checked={isCounterCheckboxChecked} onChange={handleCounterCheckboxChecked} />
                                            </div>
                                        </div>
                                        <div className='form-group-input'>
                                            <select style={{ textTransform: "capitalize" }}
                                                name="CounterBalance"
                                                // className="form-select form-control dashboard-input-box-3 select-custom-boxx"
                                                className={`form-select form-control dashboard-input-box-3 select-custom-boxx ${!isCounterCheckboxChecked ? "select-disabled" : ""
                                                    }`}
                                                aria-label="Default select example"
                                                disabled={!isCounterCheckboxChecked}
                                                value={buildSheetData?.CounterBalance || ""} onChange={handleChange}
                                            >
                                                <option value="" disabled selected>Weight</option>
                                                {counterBalances.map((weight) => (
                                                    <option key={weight} value={weight}>
                                                        {weight} grams
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='row'>
                                <div className='col-md-12'>
                                    <div className='form-group'>
                                        <div className='form-group-label'>
                                            <label className='form-label'>Grip</label>
                                        </div>
                                        <div className='row'>
                                            <div className='col-md-6'>
                                                <div className='form-group-input mb-4'>
                                                    <select style={{ textTransform: "capitalize" }} name="Grip.brand" value={buildSheetData?.Grip?.brand || ""} onChange={handleChange} class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example">
                                                        <option value="" disabled>Brand</option>
                                                        {gripdata && gripdata.map((item) => (
                                                            <option value={item._id} key={item._id}>{item.brand_name}</option>
                                                        ))}
                                                        {/* <option value="1">1 ft.</option>
                                        <option value="2">2 ft.</option>
                                        <option value="3">3 ft.</option> */}
                                                    </select>
                                                </div>
                                            </div>
                                            <div className='col-md-6'>
                                                <div className='form-group-input mb-4'>
                                                    <select style={{ textTransform: "capitalize" }} name="Grip.model" value={buildSheetData?.Grip?.model || ""} onChange={handleChange} class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example">
                                                        <option value="" disabled>Model</option>
                                                        {gripmodeldata && gripmodeldata.map((item) => (
                                                            <option value={item._id} key={item._id}>{item.ModelName}</option>
                                                        ))}
                                                        {/* <option value="1">1 ft.</option>
                                        <option value="2">2 ft.</option>
                                        <option value="3">3 ft.</option> */}
                                                    </select>
                                                </div>
                                            </div>
                                            <div className='col-md-12'>
                                                <div className='form-group-input mb-4'>
                                                    <select style={{ textTransform: "capitalize" }}
                                                        name="Grip.size"
                                                        className="form-select form-control dashboard-input-box-3 select-custom-boxx"
                                                        aria-label="Default select example"
                                                        value={buildSheetData?.Grip?.size || ""} onChange={handleChange}
                                                    >
                                                        <option value="" disabled selected>Size</option>
                                                        {gripSize.map((gripSize) => (
                                                            <option key={gripSize} value={gripSize}>
                                                                {gripSize}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </div>
                                            <div className='col-md-12'>
                                                <div className='form-group-input'>
                                                    <select style={{ textTransform: "capitalize" }}
                                                        name="Grip.label"
                                                        className="form-select form-control dashboard-input-box-3 select-custom-boxx"
                                                        aria-label="Default select example"
                                                        value={buildSheetData?.Grip?.label || ""} onChange={handleChange}
                                                    >
                                                        <option value="" disabled selected>Label</option>
                                                        {gripLabels.map((gripLabels) => (
                                                            <option key={gripLabels} value={gripLabels}>
                                                                {gripLabels}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='row'>
                                <div className='col-md-12'>
                                    <div className='form-group'>
                                        <div className='form-group-label d-flex align-items-center justify-content-between'>
                                            <label className='form-label'>Grip Wrap</label>
                                            <div className='form-group-check'>
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input"
                                                    checked={buildSheetData.GripWrapStatus}
                                                    onChange={handleGripWrapCheckbox}
                                                />
                                            </div>
                                        </div>
                                        <div className='form-group-input'>
                                            <select
                                                style={{ textTransform: "capitalize" }}
                                                name="GripWrap"
                                                className={`form-select form-control dashboard-input-box-3 select-custom-boxx ${!buildSheetData.GripWrapStatus ? "select-disabled" : ""}`}
                                                aria-label="Default select example"
                                                disabled={!buildSheetData.GripWrapStatus}
                                                value={buildSheetData.GripWrapValue}
                                                onChange={handleGripWrapChange}
                                            >
                                                <option value="" disabled>Choose Grip Wrap</option>
                                                {gripWrapOptions.map((wrap) => (
                                                    <option key={wrap} value={wrap}>{wrap}</option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='row'>
                                <div className='col-md-12'>
                                    <div className='form-group'>
                                        <div className='form-group-label d-flex align-items-center justify-content-between'>
                                            <label className='form-label'>Grip Notes</label>
                                        </div>
                                        <div className='form-group-input'>
                                            <textarea name="GripNotes" value={buildSheetData?.GripNotes || ""} onChange={handleChange} class="form-control dashboard-text-area" id="exampleFormControlTextarea1" rows="8" ></textarea>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='row'>
                                <div className='col-md-12'>
                                    <div className='form-group'>
                                        <div className='form-group-label d-flex align-items-center justify-content-between'>
                                            <label className='form-label'>Ferrule</label>
                                        </div>
                                        <div className='form-group-input'>
                                            <textarea name="Ferrule" value={buildSheetData?.Ferrule || ""} onChange={handleChange} class="form-control dashboard-text-area" id="exampleFormControlTextarea1" rows="8" ></textarea>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='row'>
                                <div className='full-width-btn'>
                                    <>
                                        {buildSheetStatus === "true" ? (
                                            <button className="btn btn-primary btn-create" onClick={updateclub}>
                                                {apicallupate ? (<Spinner animation="border" className="border-black" />) : (<span>Update Club</span>)}
                                            </button>
                                        ) : (
                                            <button className="btn btn-primary btn-create" onClick={submitdata}>
                                                {apicallupate ? (<Spinner animation="border" className="border-black" />) : (<span>Add Club</span>)}
                                            </button>
                                        )}
                                    </>
                                </div>
                            </div>
                        </div>
                        <div className="scrollable-section1 col-sm-6 col-12">
                            <div className='form-group m-0'>
                                <div className='form-group-label'>
                                    <label className='form-label'>Prescription</label>
                                </div>
                            </div>
                            <div className="tab-container tab-club-fitting mb-3"><div className="tab-box-section p-0">
                                <div className="accordion-section">
                                    <Accordion defaultActiveKey="0">
                                        <Accordion.Item eventKey="0" className="results-accordion">
                                            <div className="gs_b p-0 club-fitting-card  accordion-item">
                                                <div className="accordion_card_view" id="lesson_card_1">
                                                    <Accordion.Header>
                                                        <div className="gab_title">
                                                            <div className="gab_text text-left">
                                                                <h5>
                                                                    <span className="color"></span>
                                                                    <div className="d-flex align-items-center gap-1">Bounce: <div className="light-text">{getselectbounce("bounce", prescriptionNew?.bouncedropdownselect)}</div></div>
                                                                </h5>
                                                            </div>
                                                            <div className="collapsed">
                                                                <div className="gab_icon ">
                                                                    <FaAngleUp />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </Accordion.Header>
                                                </div>
                                                <Accordion.Body className="results-accordion-body">
                                                    <div className="irons-content">
                                                        <div className="result-club">
                                                            <textarea className="dashboard-text-area" style={{ color: '#ffffff', pointerEvents: 'none' }} value={prescriptionNew?.bounce} rows="3" placeholder="Enter your script here"></textarea>
                                                        </div>
                                                    </div>
                                                </Accordion.Body>
                                            </div>
                                        </Accordion.Item>
                                    </Accordion>
                                </div>
                            </div>
                            </div>
                            <div className="tab-container tab-club-fitting mb-3"><div className="tab-box-section p-0">
                                <div className="accordion-section">
                                    <Accordion defaultActiveKey="0">
                                        <Accordion.Item eventKey="0" className="results-accordion black">
                                            <div className="gs_b p-0 club-fitting-card  accordion-item">
                                                <div className="accordion_card_view" id="lesson_card_1">
                                                    <Accordion.Header>
                                                        <div className="gab_title">
                                                            <div className="gab_text text-left">
                                                                <h5>
                                                                    <span className="color"></span>
                                                                    <div className="d-flex align-items-center gap-1">Lie Angle: <div className="light-text">{getselectbounce("lieAngle", prescriptionNew?.lieagedropdownselect)}</div></div>
                                                                </h5>
                                                            </div>
                                                            <div className="collapsed">
                                                                <div className="gab_icon ">
                                                                    <FaAngleUp />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </Accordion.Header>
                                                </div>
                                                <Accordion.Body className="results-accordion-body">
                                                    <div className="irons-content">
                                                        <div className="result-club">
                                                            <textarea className="dashboard-text-area" value={prescriptionNew?.lieage} style={{ color: '#ffffff', pointerEvents: 'none' }} rows="3" placeholder="Enter your script here"></textarea>
                                                        </div>
                                                    </div>
                                                </Accordion.Body>
                                            </div>
                                        </Accordion.Item>

                                    </Accordion>
                                </div>
                            </div>
                            </div>
                            <div className="tab-container tab-club-fitting mb-3"><div className="tab-box-section p-0">
                                <div className="accordion-section">
                                    <Accordion defaultActiveKey="0">
                                        <Accordion.Item eventKey="0" className="results-accordion blue">
                                            <div className="gs_b p-0 club-fitting-card  accordion-item">
                                                <div className="accordion_card_view" id="lesson_card_1">
                                                    <Accordion.Header>
                                                        <div className="gab_title">
                                                            <div className="gab_text text-left">
                                                                <h5>
                                                                    <span className="color"></span>
                                                                    <div className="d-flex align-items-center gap-1">Shaft Weight: <div className="light-text">{getselectbounce("shaftWeight", prescriptionNew?.shaftweightdropdownselect)}</div></div>
                                                                </h5>
                                                            </div>
                                                            <div className="collapsed">
                                                                <div className="gab_icon ">
                                                                    <FaAngleUp />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </Accordion.Header>
                                                </div>
                                                <Accordion.Body className="results-accordion-body">
                                                    <div className="irons-content">
                                                        <div className="result-club">
                                                            <textarea className="dashboard-text-area" rows="3" value={prescriptionNew?.shaftweight} style={{ color: '#ffffff', pointerEvents: 'none' }} placeholder="Enter your script here"></textarea>
                                                        </div>
                                                    </div>
                                                </Accordion.Body>
                                            </div>
                                        </Accordion.Item>

                                    </Accordion>
                                </div>
                            </div>
                            </div>
                            <div className="tab-container tab-club-fitting mb-3"><div className="tab-box-section p-0">
                                <div className="accordion-section">
                                    <Accordion defaultActiveKey="0">
                                        <Accordion.Item eventKey="0" className="results-accordion pink">
                                            <div className="gs_b p-0 club-fitting-card  accordion-item">
                                                <div className="accordion_card_view" id="lesson_card_1">
                                                    <Accordion.Header>
                                                        <div className="gab_title">
                                                            <div className="gab_text text-left">
                                                                <h5>
                                                                    <span className="color"></span>
                                                                    <div className="d-flex align-items-center gap-1">Shaft Flex: <div className="light-text">{getselectbounce("shaftFlex", prescriptionNew?.shaftflexdropdownselect)}</div></div>
                                                                </h5>
                                                            </div>
                                                            <div className="collapsed">
                                                                <div className="gab_icon ">
                                                                    <FaAngleUp />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </Accordion.Header>
                                                </div>
                                                <Accordion.Body className="results-accordion-body">
                                                    <div className="irons-content">
                                                        <div className="result-club">
                                                            <textarea className="dashboard-text-area" rows="3" value={prescriptionNew?.shaftflex} style={{ color: '#ffffff', pointerEvents: 'none' }} placeholder="Enter your script here"></textarea>
                                                        </div>
                                                    </div>
                                                </Accordion.Body>
                                            </div>
                                        </Accordion.Item>

                                    </Accordion>
                                </div>
                            </div>
                            </div>
                            <div className="tab-container tab-club-fitting mb-3"><div className="tab-box-section p-0">
                                <div className="accordion-section">
                                    <Accordion defaultActiveKey="0">
                                        <Accordion.Item eventKey="0" className="results-accordion red">
                                            <div className="gs_b p-0 club-fitting-card  accordion-item">
                                                <div className="accordion_card_view" id="lesson_card_1">
                                                    <Accordion.Header>
                                                        <div className="gab_title">
                                                            <div className="gab_text text-left">
                                                                <h5>
                                                                    <span className="color"></span>
                                                                    <div className="d-flex align-items-center gap-1">Grip Size: <div className="light-text">{getselectbounce("gripSize", prescriptionNew?.gripSizedropdownselect)}</div></div>
                                                                </h5>
                                                            </div>
                                                            <div className="collapsed">
                                                                <div className="gab_icon ">
                                                                    <FaAngleUp />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </Accordion.Header>
                                                </div>
                                                <Accordion.Body className="results-accordion-body">
                                                    <div className="irons-content">
                                                        <div className="result-club">
                                                            <textarea className="dashboard-text-area" rows="3" value={prescriptionNew?.gripSize} style={{ color: '#ffffff', pointerEvents: 'none' }} placeholder="Enter your script here"></textarea>
                                                        </div>
                                                    </div>
                                                </Accordion.Body>
                                            </div>
                                        </Accordion.Item>

                                    </Accordion>
                                </div>
                            </div>
                            </div>
                            <div className="tab-container tab-club-fitting mb-3"><div className="tab-box-section p-0">
                                <div className="accordion-section">
                                    <Accordion defaultActiveKey="0">
                                        <Accordion.Item eventKey="0" className="results-accordion orange">
                                            <div className="gs_b p-0 club-fitting-card  accordion-item">
                                                <div className="accordion_card_view" id="lesson_card_1">
                                                    <Accordion.Header>
                                                        <div className="gab_title">
                                                            <div className="gab_text text-left">
                                                                <h5>
                                                                    <span className="color"></span>
                                                                    <div className="d-flex align-items-center gap-1">Club Length: <div className="light-text">{getselectbounce("clubLength", prescriptionNew?.clubLengthdropdownselect)}</div></div>
                                                                </h5>
                                                            </div>
                                                            <div className="collapsed">
                                                                <div className="gab_icon ">
                                                                    <FaAngleUp />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </Accordion.Header>
                                                </div>
                                                <Accordion.Body className="results-accordion-body">
                                                    <div className="irons-content">
                                                        <div className="result-club">
                                                            <textarea className="dashboard-text-area" rows="3" value={prescriptionNew?.clubLength} style={{ color: '#ffffff', pointerEvents: 'none' }} placeholder="Enter your script here"></textarea>
                                                        </div>
                                                    </div>
                                                </Accordion.Body>
                                            </div>
                                        </Accordion.Item>

                                    </Accordion>
                                </div>
                            </div>
                            </div>
                            <div className="tab-container tab-club-fitting mb-3"><div className="tab-box-section p-0">
                                <div className="accordion-section">
                                    <Accordion defaultActiveKey="0">
                                        <Accordion.Item eventKey="0" className="results-accordion green">
                                            <div className="gs_b p-0 club-fitting-card  accordion-item">
                                                <div className="accordion_card_view" id="lesson_card_1">
                                                    <Accordion.Header>
                                                        <div className="gab_title">
                                                            <div className="gab_text text-left">
                                                                <h5>
                                                                    <span className="color"></span>
                                                                    <div className="d-flex align-items-center gap-1">Swing Weight: <div className="light-text">{getselectbounce("swingWeight", prescriptionNew?.swingWeightdropdownselect)}</div></div>
                                                                </h5>
                                                            </div>
                                                            <div className="collapsed">
                                                                <div className="gab_icon ">
                                                                    <FaAngleUp />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </Accordion.Header>
                                                </div>
                                                <Accordion.Body className="results-accordion-body">
                                                    <div className="irons-content">
                                                        <div className="result-club">
                                                            <textarea className="dashboard-text-area" rows="3" value={prescriptionNew?.swingWeight} style={{ color: '#ffffff', pointerEvents: 'none' }} placeholder="Enter your script here"></textarea>
                                                        </div>
                                                    </div>
                                                </Accordion.Body>
                                            </div>
                                        </Accordion.Item>

                                    </Accordion>
                                </div>
                            </div>
                            </div>
                            <div className="tab-container tab-club-fitting mb-3"><div className="tab-box-section p-0">
                                <div className="accordion-section">
                                    <div className="tab-box-section mb-4">
                                        <div className="">
                                            <div className="club-fitting-card black_box">
                                            </div>
                                            <div className="form-group prescription-note presc-tab2">
                                                <div className="row mb-3">
                                                    {optimalHeads === 1 && (
                                                        <>
                                                            <div className="row mb-3 align-items-center">
                                                                <label className="col-2 col-sm-2" style={{ marginTop: '10px', marginRight: '-30px' }}>
                                                                    <svg stroke="currentColor" fill="#aee750" strokeWidth="0" viewBox="0 0 576 512" height="37" width="37" xmlns="http://www.w3.org/2000/svg">
                                                                        <path d="M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"></path>
                                                                    </svg>
                                                                </label>
                                                                <div className="col-5 col-sm-5 mb-3">
                                                                    <select disabled value={optimalHeadsobject?.option1?.make} className="form-select form-control dashboard-input-box-3 select-custom-boxx">
                                                                        <option value="" disabled>Make</option>
                                                                        {makedata && makedata.map((item) => (
                                                                            <option value={item._id} key={item._id}>{item.brand_name}</option>
                                                                        ))}
                                                                    </select>
                                                                </div>
                                                                <div className="col-5 col-sm-5 mb-3">
                                                                    <select disabled value={optimalHeadsobject?.option1?.model} className="form-select form-control dashboard-input-box-3 select-custom-boxx">
                                                                        <option value="" disabled>Model</option>
                                                                        {head1 && head1.map((item) => (
                                                                            <option value={item._id} key={item._id}>{item.ModelName}</option>
                                                                        ))}
                                                                    </select>
                                                                </div>
                                                            </div>
                                                        </>
                                                    )}
                                                    {optimalHeads === 2 && (
                                                        <>
                                                            <div className="row mb-3 align-items-center">
                                                                <label className="col-2 col-sm-2" style={{ marginTop: '10px', marginRight: '-30px' }}>
                                                                    <svg stroke="currentColor" fill="#aee750" strokeWidth="0" viewBox="0 0 576 512" height="37" width="37" xmlns="http://www.w3.org/2000/svg">
                                                                        <path d="M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"></path>
                                                                    </svg>
                                                                </label>
                                                                <div className="col-5 col-sm-5 mb-3">
                                                                    <select disabled value={optimalHeadsobject?.option2?.make} onChange={(e) => handleNestedChange('optimalHeads', 2, 'make', e.target.value)} className="form-select form-control dashboard-input-box-3 select-custom-boxx">
                                                                        <option value="" disabled>Make</option>
                                                                        {makedata && makedata.map((item) => (
                                                                            <option value={item._id} key={item._id}>{item.brand_name}</option>
                                                                        ))}
                                                                    </select>
                                                                </div>
                                                                <div className="col-5 col-sm-5 mb-3">
                                                                    <select disabled value={optimalHeadsobject?.option2?.model} className="form-select form-control dashboard-input-box-3 select-custom-boxx">
                                                                        <option value="" disabled>Model</option>
                                                                        {head2 && head2.map((item) => (
                                                                            <option value={item._id} key={item._id}>{item.ModelName}</option>
                                                                        ))}
                                                                    </select>
                                                                </div>
                                                            </div>
                                                        </>
                                                    )}
                                                    {optimalHeads === 3 && (
                                                        <>
                                                            <div className="row mb-3 align-items-center">
                                                                <label className="col-2 col-sm-2" style={{ marginTop: '10px', marginRight: '-30px' }}>
                                                                    <svg stroke="currentColor" fill="#aee750" strokeWidth="0" viewBox="0 0 576 512" height="37" width="37" xmlns="http://www.w3.org/2000/svg">
                                                                        <path d="M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"></path>
                                                                    </svg>
                                                                </label>
                                                                <div className="col-5 col-sm-5 mb-3">
                                                                    <select disabled value={optimalHeadsobject?.option3?.make} onChange={(e) => handleNestedChange('optimalHeads', 3, 'make', e.target.value)} className="form-select form-control dashboard-input-box-3 select-custom-boxx">
                                                                        <option value="" disabled>Make</option>
                                                                        {makedata && makedata.map((item) => (
                                                                            <option value={item._id} key={item._id}>{item.brand_name}</option>
                                                                        ))}
                                                                    </select>
                                                                </div>
                                                                <div className="col-5 col-sm-5 mb-3">
                                                                    <select disabled value={optimalHeadsobject?.option3?.model} className="form-select form-control dashboard-input-box-3 select-custom-boxx">
                                                                        <option value="" disabled>Model</option>
                                                                        {head3 && head3.map((item) => (
                                                                            <option value={item._id} key={item._id}>{item.ModelName}</option>
                                                                        ))}
                                                                    </select>
                                                                </div>
                                                            </div>
                                                        </>
                                                    )}

                                                    {optimalShafts === 1 && (
                                                        <>
                                                            <div className="row mb-3 align-items-center">
                                                                <label className="col-2 col-sm-2" style={{ marginTop: '10px', marginRight: '-30px' }} >
                                                                    <svg stroke="currentColor" fill={`${optimalShafts === 1 ? '#aee750' : '#404650'}`} stroke-width="0" viewBox="0 0 576 512" height="37" width="37" xmlns="http://www.w3.org/2000/svg"><path d="M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"></path></svg>
                                                                </label>
                                                                <div className="col-5 col-sm-5 mb-3">
                                                                    <select disabled value={optimalShaftsobject?.option1?.make || ""} onChange={(e) => handleNestedChange('optimalShafts', 1, 'make', e.target.value)} class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example">
                                                                        <option value="" disabled>Make</option>
                                                                        {shaftdata && shaftdata.map((item) => (
                                                                            <option value={item._id} key={item._id}>{item.brand_name}</option>
                                                                        ))}
                                                                    </select>
                                                                </div>
                                                                <div className="col-5 col-sm-5 mb-3">
                                                                    <select disabled value={optimalShaftsobject?.option1?.model || ""} class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example">
                                                                        <option value="" disabled>Model</option>
                                                                        {Shaft1 && Shaft1.map((item) => (
                                                                            <option value={item._id} key={item._id}>{item.ModelName}</option>
                                                                        ))}
                                                                    </select>
                                                                </div>
                                                            </div>
                                                        </>
                                                    )}

                                                    {optimalShafts === 2 && (
                                                        <>
                                                            <div className="row mb-3 align-items-center">
                                                                <label className="col-2 col-sm-2 " style={{ marginTop: '10px', marginRight: '-30px' }} >
                                                                    <svg stroke="currentColor" fill={`${optimalShafts === 2 ? '#aee750' : '#404650'}`} stroke-width="0" viewBox="0 0 576 512" height="37" width="37" xmlns="http://www.w3.org/2000/svg"><path d="M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"></path></svg>
                                                                </label>
                                                                <div className="col-5 col-sm-5 mb-3">
                                                                    <select disabled value={optimalShaftsobject?.option2?.make || ""} onChange={(e) => handleNestedChange('optimalShafts', 2, 'make', e.target.value)} class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example">
                                                                        <option value="" disabled>Make</option>
                                                                        {shaftdata && shaftdata.map((item) => (
                                                                            <option value={item._id} key={item._id}>{item.brand_name}</option>
                                                                        ))}
                                                                    </select>
                                                                </div>
                                                                <div className="col-5 col-sm-5 mb-3">
                                                                    <select disabled value={optimalShaftsobject?.option2?.model || ""} class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example">
                                                                        <option value="" disabled>Model</option>
                                                                        {Shaft2 && Shaft2.map((item) => (
                                                                            <option value={item._id} key={item._id}>{item.ModelName}</option>
                                                                        ))}
                                                                    </select>
                                                                </div>
                                                            </div>
                                                        </>
                                                    )}

                                                    {optimalShafts === 3 && (
                                                        <>
                                                            <div className="row mb-3 align-items-center">
                                                                <label className="col-2 col-sm-2"
                                                                    style={{ marginTop: '10px', marginRight: '-30px' }}
                                                                ><svg stroke="currentColor" fill={`${optimalShafts === 3 ? '#aee750' : '#404650'}`} stroke-width="0" viewBox="0 0 576 512" height="37" width="37" xmlns="http://www.w3.org/2000/svg"><path d="M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"></path></svg></label>
                                                                <div className="col-5 col-sm-5 mb-3">
                                                                    <select disabled value={optimalShaftsobject?.option3?.make || ""} onChange={(e) => handleNestedChange('optimalShafts', 3, 'make', e.target.value)} class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example">
                                                                        <option value="" disabled>Make</option>
                                                                        {shaftdata && shaftdata.map((item) => (
                                                                            <option value={item._id} key={item._id}>{item.brand_name}</option>
                                                                        ))}
                                                                    </select>
                                                                </div>
                                                                <div className="col-5 col-sm-5 mb-3">
                                                                    <select disabled value={optimalShaftsobject?.option3?.model || ""} class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example">
                                                                        <option value="" disabled>Model</option>
                                                                        {Shaft3 && Shaft3.map((item) => (
                                                                            <option value={item._id} key={item._id}>{item.ModelName}</option>
                                                                        ))}
                                                                    </select>
                                                                </div>
                                                            </div>
                                                        </>
                                                    )}

                                                    {optimalGrips === 1 && (
                                                        <>
                                                            <div className="row mb-3 align-items-center">
                                                                <label className="col-2 col-sm-2"
                                                                    style={{ marginTop: '10px', marginRight: '-30px' }}
                                                                ><svg stroke="currentColor" fill={`${optimalGrips === 1 ? '#aee750' : '#404650'}`} stroke-width="0" viewBox="0 0 576 512" height="37" width="37" xmlns="http://www.w3.org/2000/svg"><path d="M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"></path></svg></label>
                                                                <div className="col-5 col-sm-5 mb-3">
                                                                    <select disabled value={optimalGripsobject?.option1?.make} onChange={(e) => handleNestedChange('optimalGrips', 1, 'make', e.target.value)} class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example">
                                                                        <option value="" disabled>Make</option>
                                                                        {gripdata && gripdata.map((item) => (
                                                                            <option value={item._id} key={item._id}>{item.brand_name}</option>
                                                                        ))}
                                                                    </select>
                                                                </div>
                                                                <div className="col-5 col-sm-5 mb-3">
                                                                    <select disabled value={optimalGripsobject?.option1?.model} class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example">
                                                                        <option value="" disabled>Model</option>
                                                                        {Grip1 && Grip1.map((item) => (
                                                                            <option value={item._id} key={item._id}>{item.ModelName}</option>
                                                                        ))}
                                                                    </select>
                                                                </div>
                                                            </div>
                                                        </>
                                                    )}

                                                    {optimalGrips === 2 && (
                                                        <>
                                                            <div className="row mb-3 align-items-center">
                                                                <label className="col-2 col-sm-2"
                                                                    style={{ marginTop: '10px', marginRight: '-30px' }}
                                                                ><svg stroke="currentColor" fill={`${optimalGrips === 2 ? '#aee750' : '#404650'}`} stroke-width="0" viewBox="0 0 576 512" height="37" width="37" xmlns="http://www.w3.org/2000/svg"><path d="M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"></path></svg></label>
                                                                <div className="col-5 col-sm-5 mb-3">
                                                                    <select disabled value={optimalGripsobject?.option2?.make} onChange={(e) => handleNestedChange('optimalGrips', 2, 'make', e.target.value)} class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example">
                                                                        <option value="" disabled>Make</option>
                                                                        {gripdata && gripdata.map((item) => (
                                                                            <option value={item._id} key={item._id}>{item.brand_name}</option>
                                                                        ))}
                                                                    </select>
                                                                </div>
                                                                <div className="col-5 col-sm-5 mb-3">
                                                                    <select disabled value={optimalGripsobject?.option2?.model} class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example">
                                                                        <option value="" disabled>Model</option>
                                                                        {Grip2 && Grip2.map((item) => (
                                                                            <option value={item._id} key={item._id}>{item.ModelName}</option>
                                                                        ))}
                                                                    </select>
                                                                </div>
                                                            </div>
                                                        </>
                                                    )}

                                                    {optimalGrips === 3 && (
                                                        <>
                                                            <div className="row mb-3 align-items-center">
                                                                <label className="col-2 col-sm-2"
                                                                    style={{ marginTop: '10px', marginRight: '-30px' }}
                                                                ><svg stroke="currentColor" fill={`${optimalGrips === 3 ? '#aee750' : '#404650'}`} stroke-width="0" viewBox="0 0 576 512" height="37" width="37" xmlns="http://www.w3.org/2000/svg"><path d="M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"></path></svg></label>
                                                                <div className="col-5 col-sm-5 mb-3">
                                                                    <select disabled value={optimalGripsobject?.option3?.make} onChange={(e) => handleNestedChange('optimalGrips', 3, 'make', e.target.value)} class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example">
                                                                        <option value="" disabled>Make</option>
                                                                        {gripdata && gripdata.map((item) => (
                                                                            <option value={item._id} key={item._id}>{item.brand_name}</option>
                                                                        ))}
                                                                    </select>
                                                                </div>
                                                                <div className="col-5 col-sm-5 mb-3">
                                                                    <select disabled value={optimalGripsobject?.option3?.model} class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example">
                                                                        <option value="" disabled>Model</option>
                                                                        {Grip3 && Grip3.map((item) => (
                                                                            <option value={item._id} key={item._id}>{item.ModelName}</option>
                                                                        ))}
                                                                    </select>
                                                                </div>
                                                            </div>
                                                        </>
                                                    )}


                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            </div>
                        </div>
                    </div>
                </fieldset>
            </Form>
            <style>
                {`
                    .scrollable-section {
                    height: 100vh;
  overflow-y: auto; /* Enable vertical scrolling */
  padding: 10px;
}
  .scrollable-section::-webkit-scrollbar {
  width: 0px;
}

.scrollable-section::-webkit-scrollbar-thumb {
  background-color: #888;
  border-radius: 4px;
}

.scrollable-section::-webkit-scrollbar-thumb:hover {
  background-color: #555;}
                    .scrollable-section1 {
                    height: 100vh;
  overflow-y: auto; /* Enable vertical scrolling */
  padding: 10px;
}
  .scrollable-section1::-webkit-scrollbar {
  width: 0px;
}

.scrollable-section1::-webkit-scrollbar-thumb {
  background-color: #888;
  border-radius: 4px;
}

.scrollable-section1::-webkit-scrollbar-thumb:hover {
  background-color: #555;
}
                `}
            </style>
        </>
    );
}

export default DriverWood;